import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "./sidebar.css"; 

function Display() {
  const location = useLocation();
  const { database } = location.state || {};

  return (
    <div className="container">
      <Sidebar database={database} />
      <main className="main-content">
        <div style={{ textAlign: "left", margin: "30px 20px" }}>
          [1] Click on "Add Blog" Button to add a new blog.
          <br />
          <br /> [2] Click on Edit icon in the blog list to edit the blog.
          <br />
          <br /> [3] Click on Delete icon in the blog list to delete the blog.
        </div>
      </main>
    </div>
  );
}

export default Display;

